/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HeartbeatStatus } from '../models/HeartbeatStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MonitoringService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns HeartbeatStatus OK
     * @throws ApiError
     */
    public heartbeat(): CancelablePromise<HeartbeatStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/monitoring/heartbeat',
            errors: {
                500: `Not OK`,
            },
        });
    }

}
